import { cssUtil } from "../../utils/cssUtil.js";
import { getBaseStyles } from "../commonStyles.js";
import { getCardFlexConfig } from "components/Editor/widgets/carousel/card/flexConfig";
import _ from "lodash";

export async function renderCarouselWidget(context, widget, parent, override = null) {

    const breakpoint = context.currentBreakpoint;

    const cards = _.sortBy(context.widgets.filter(w => w.parent === widget.uid), "order");
    const firstCardFlex = cards[0] ? getCardFlexConfig(cards[0], breakpoint).flexBoxEnabled : false;
    const freeSize = widget?.properties?.desktop?.free === true;
    const flexKeepsFixedBox = firstCardFlex && freeSize && breakpoint === "desktop";

    const el = context.document.createElement("div");
    el.classList.add("widget", "carousel_widget");

    const styles = {
        ...getBaseStyles(widget, breakpoint),
        ...getCarouselStyles(widget),
        ...(firstCardFlex && !flexKeepsFixedBox ? { height: "auto" } : {})
    };

    el.setAttribute("style", cssUtil.toStyleString(styles));
    el.setAttribute("data-widgetId", widget.uid);
    el.setAttribute("data-widgetType", widget.type);
    el.setAttribute("data-widgetParent", widget.parent);

    parent.appendChild(el);

    const children = cards;
    if (!children || !children.length) return el;

    for (let i = 0; i < children.length; i++) {
        const child = children[i];
    
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;
    
        const renderer = context.renderers[child.type];
        if (!renderer) continue;
    
        const childOverride = i === 0 ? null : true;
    
        await renderer(context, child, el, childOverride);
    }    

    return el;
}

function getCarouselStyles(widget) {
    const styles = {};

    const props = widget?.properties?.desktop;
    if (!props) return styles;

    const layout = props.layout;

    if ((!layout?.width || layout.width === "") && props.stretched === true) {
        styles.width = "100%";
    }

    return styles;
}